<template>
  <div class="border-bottom pb-3 mb-3">
    <b-row>
      <b-col :lg="showSave ? 4 : 6" class="mb-2 mb-lg-0">
        <FormInput
          v-model="task.description"
          :i18n="{ placeholder: 'SERVICE_VISITS.CUSTOM_TASK' }"
          :disabled="readonly || saving"
        />
      </b-col>
      <b-col lg="2" class="mb-2 mb-lg-0">
        <FormSelect
          v-model="task.statusId"
          :options="itemStatuses"
          :placeholder="$t('FORM_LABELS.STATUS')"
          :disabled="readonly || saving"
        />
      </b-col>
      <b-col lg="3" class="mb-2 mb-lg-0">
        <b-form-textarea
          v-model="task.note"
          rows="1"
          max-rows="4"
          :placeholder="$t('FORM_LABELS.NOTE')"
          :disabled="readonly || saving"
        />
      </b-col>
      <b-col v-if="!showSave" lg="1" class="d-flex justify-content-end">
        <v-btn
          v-if="showRemove && !readonly"
          icon
          color="error"
          @click="$emit('remove')"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </b-col>
      <b-col
        v-else
        lg="3"
        class="d-flex justify-content-end align-items-start"
      >
        <button
          type="button"
          class="btn btn-light-danger font-weight-bolder mr-2"
          :disabled="saving"
          @click="$emit('cancel')"
        >
          {{ $t("BUTTON.CANCEL") }}
        </button>
        <SaveButton
          :is-loading="saving"
          :disabled="!canSave"
          @save="$emit('save')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormInput from "@/view/content/forms/components/FormInput.vue";
import FormSelect from "@/view/content/forms/components/FormSelect.vue";
import SaveButton from "@/view/content/forms/components/SaveButton.vue";

export default {
  name: "ServiceVisitCustomTaskRow",
  components: {
    FormInput,
    FormSelect,
    SaveButton
  },
  props: {
    task: {
      type: Object,
      required: true
    },
    itemStatuses: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    showRemove: {
      type: Boolean,
      default: false
    },
    showSave: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canSave() {
      return Boolean(this.task.description && this.task.description.trim() && this.task.statusId);
    }
  }
};
</script>
